// extracted by mini-css-extract-plugin
export default {"notificationsZIndex":"14000","container":"_3VDmOqX2hq","queueButton":"_1ClMdku_6-","icon":"_371r_EGw1D"};